import { useState } from 'react';
import moment from 'moment'
import {t} from 'i18next'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'

import { displayDate } from '../izUtils';

const DisplayHistory = ({history, data}) => {
    const [historyModalOpen, setHistoryModalOpen] = useState(false);

    const displayValue = (value) => {
        if (data.type === 'checkbox' || data.type === 'bool') {
            return value ? "✔" : "✘";
        } else {
            return value;
        }
    }

    return (
        <>
            <div className='d-flex justify-content-end mt-1'>
                <Button color="primary" outline size="xs" onClick={() => setHistoryModalOpen(true)}>{t('history.show')}</Button>
            </div>
            <Modal isOpen={historyModalOpen} toggle={() => setHistoryModalOpen(prev => !prev)} centered size="md">
                <ModalHeader toggle={() => setHistoryModalOpen(prev => !prev)}>{t('history.title', { field: data?.title })}</ModalHeader>
                <ModalBody>
                    {history?.map((h, index) => (
                        <div key={index} className="mb-3">
                            <div><b>{displayDate(moment.utc(h?.createdAt))}&nbsp;-&nbsp;{h?.changedBy}</b></div>
                            <span style={{ textDecoration: 'line-through' }}>{displayValue(h?.oldValue)}</span>
                            &nbsp;&nbsp;&rarr;&nbsp;&nbsp;
                            <span>{displayValue(h?.newValue)}</span>
                        </div>
                    ))}
                </ModalBody>
            </Modal>
        </>
    )
}

export default DisplayHistory